<template>
  <router-link to="/request/service" tag="div" class="box has-cursor-pointer">
    <div class="is-flex" v-if="!loading">
      <h1 class="is-size-6 is-uppercase is-expanded">{{ status }}</h1>
      <h1 class="is-size-6 count">{{ totalDocs }}</h1>
    </div>
    <div class="has-text-centered" v-if="loading">
      <button class="button is-borderless is-loading"></button>
    </div>
  </router-link>
</template>
<script>
import http from "@/http";
export default {
  props: {
    status: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      totalDocs: 0
    };
  },
  mounted() {
    let component = this;
    component.loading = true;
    http
      .post("/request/service/index", { status: component.status })
      .then(response => {
        component.loading = false;
        component.totalDocs = response.data.totalDocs;
      });
  }
};
</script>
